import { getEnvironmentUrlLegacyApi } from './getEnvironmentUrlLegacyApi';

export async function getLabels<T = unknown>(
  authToken: string,
  environment: Parameters<typeof getEnvironmentUrlLegacyApi>[0],
): Promise<T> {
  const response = await fetch(`${getEnvironmentUrlLegacyApi(environment)}?method=getUserTags`, {
    method: 'GET',
    headers: new Headers({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${authToken}`,
    }),
  });
  if (!response.ok) {
    throw new Error('Could not retrieve labels');
  }
  return await response.json();
}
